// ÐÑÐ±Ð¾Ñ ÑÐ·ÑÐºÐ° Ð¿Ð¾Ð´ÑÐºÐ°Ð·Ð¾Ðº.
//
// ÐÐ½ÑÐµÑÑÐµÐ¹Ñ Ð±ÑÐ¾ÐºÐµÑÐ° Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð° ÑÑÑÑÐºÐ¾Ð¼, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐ·ÑÐº Ð¾Ð´Ð¸Ð½. ÐÐ¾Ð³Ð´Ð° Ð¿Ð¾ÑÐ²ÑÑÑÑ
// Ð¿ÐµÑÐµÐ²Ð¾Ð´Ñ, Ð´Ð¾ÑÑÐ°ÑÐ¾ÑÐ½Ð¾ Ð¿Ð¾Ð»Ð¾Ð¶Ð¸ÑÑ ÑÑÐ´Ð¾Ð¼ ÑÐ°Ð¹Ð» ÑÐ¾ ÑÐ¾Ð¹ Ð¶Ðµ ÑÑÑÑÐºÑÑÑÐ¾Ð¹, ÑÑÐ¾ `ru.js`,
// Ð¸ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÐ³Ð¾ Ð² LOCALES â Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ ÐºÐ¾Ð´ Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑÑÑ.
//
//   import kk from './kk';
//   const LOCALES = { ru, kk };

import ru from './ru';

const LOCALES = { ru };

export const DEFAULT_LOCALE = 'ru';

// Ð¯Ð·ÑÐº Ð±ÐµÑÑÐ¼ ÑÐ°Ð¼ Ð¶Ðµ, Ð³Ð´Ðµ ÐµÐ³Ð¾ Ð±ÑÐ´ÐµÑ Ð±ÑÐ°ÑÑ Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ðµ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, ÐºÐ¾Ð³Ð´Ð° Ð´Ð¾ Ð½ÐµÐ³Ð¾
// Ð´Ð¾Ð¹Ð´ÑÑ ÑÑÐºÐ¸. ÐÐµÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¸Ð»Ð¸ Ð½ÐµÑ Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð° â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÑÑÑÐºÐ¸Ð¹.
export const getLocale = () => {
  let name = DEFAULT_LOCALE;

  try {
    name = window.localStorage.getItem('lang') || DEFAULT_LOCALE;
  } catch (e) {
    name = DEFAULT_LOCALE;
  }

  return LOCALES[name] || LOCALES[DEFAULT_LOCALE];
};

export default LOCALES;
